export enum QueryParamKeys {
  MIN_INVESTMENT = "investment_for_start",
  LIST_PRICE = "clone_cost",
  INDUSTRY = "industry",
}
